import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { AppService } from "../app.service";

@Component({
  selector: "app-faq",
  templateUrl: "./faq.component.html",
  styleUrls: ["./faq.component.css"],
})
export class FaqComponent implements OnInit {
  isOpen = false;
  faqs: any;
  errStatus: boolean;
  constructor(
    private service: AppService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.spinner.show();
    this.getFAQ();
  }
  step: any;
  setStep(index: number) {
    this.step = index;
    this.isOpen = true;
  }
  closeEvent(index: number) {
    if (this.step == index) {
      this.isOpen = false;
    } else {
      this.isOpen = true;
    }
  }
  getFAQ() {
    this.service.faq().subscribe(
      (data: any) => {
        if (data) {
          this.spinner.hide();
          this.faqs = data.results;
        }
      },
      (err) => {
        this.spinner.hide();
        this.faqs = [];
        this.errStatus = true;
      }
    );
  }
}
